// Dejo este de ejemplo, si vamos a tocar los componentes de material se puede hacer asi que es facil
export default {
  MuiButton: {
    styleOverrides: {
      root: {
        margin: 0,
        padding: "8px",
        minWidth: "100%",
        "& .MuiButton-startIcon": { margin: 0 },
      },
    },
  },
};
